import {
  Avatar,
  Box,
  Button,
  Chip,
  IconButton,
  InputAdornment,
  Paper,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { MdSearch, MdVisibility } from "react-icons/md";

const DEFAULT_AVATAR_COLOR = "#1976d2";

export function UsersHeader() {
  return (
    <Box className="flex justify-between items-center mb-6">
      <Box>
        <Typography variant="h5" className="font-bold text-slate-900">
          Users
        </Typography>
        <Typography variant="body2" className="text-slate-600 mt-1">
          Manage user accounts and subscriptions
        </Typography>
      </Box>

      <Button
        variant="contained"
        sx={{
          bgcolor: "#1F4FFF",
          textTransform: "none",
          px: 3,
          py: 1.5,
          borderRadius: "10px",
          fontWeight: 600,
          "&:hover": {
            bgcolor: "#1a40d9",
          },
        }}
      >
        Export Users
      </Button>
    </Box>
  );
}

export function SearchBar({ value, onChange }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        borderRadius: "16px",
        border: "1px solid #E2E8F0",
      }}
    >
      <TextField
        fullWidth
        placeholder="Search users by name or email..."
        value={value}
        onChange={(event) => onChange(event.target.value)}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <MdSearch className="text-slate-400" size={20} />
            </InputAdornment>
          ),
        }}
      />
    </Paper>
  );
}

export function EmptyTableRow({ message }) {
  return (
    <TableRow>
      <TableCell colSpan={6}>
        <Typography className="text-slate-600 py-6 text-center">
          {message}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export function UserRow({ row, onViewUser }) {
  return (
    <TableRow
      sx={{
        "&:hover": {
          bgcolor: "#c6bbbb",
        },
        cursor: row.accountId ? "pointer" : "default",
        transition: "background-color 0.2s ease",
      }}
      hover
      onClick={() => row.accountId && onViewUser(row.accountId)}
    >
      <TableCell>
        <Box className="flex items-center gap-3">
          <Box
            sx={{
              width: 6,
              minHeight: 42,
              borderRadius: "999px",
              bgcolor: row.rowAccent.bar,
            }}
          />
          <Avatar
            sx={{
              width: 40,
              height: 40,
              bgcolor: DEFAULT_AVATAR_COLOR,
              color: "#FFFFFF",
              fontWeight: 700,
            }}
          >
            {row.name.charAt(0)}
          </Avatar>
          <Box>
            <Typography className="font-semibold text-slate-900">
              {row.name}
            </Typography>
            <Typography variant="body2" className="text-slate-500">
              {row.email}
            </Typography>
          </Box>
        </Box>
      </TableCell>

      <TableCell>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1,
            py: 0.75,
            borderRadius: "12px",
          }}
        >
          <Chip
            label={row.planName}
            size="small"
            sx={{
              bgcolor: row.planStyle.bg,
              color: row.planStyle.color,
              fontWeight: 600,
              minWidth: 88,
            }}
          />
        </Box>
      </TableCell>

      <TableCell>
        <Chip
          label={row.status}
          size="small"
          sx={{
            bgcolor: row.statusStyle.bg,
            color: row.statusStyle.color,
            fontWeight: 600,
          }}
        />
      </TableCell>

      <TableCell>
        <Typography className="text-slate-700">{row.joinedDate}</Typography>
      </TableCell>

      <TableCell>
        <Typography className="text-slate-700">{row.userType}</Typography>
      </TableCell>

      <TableCell>
        <IconButton
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            row.accountId && onViewUser(row.accountId);
          }}
          sx={{
            color: row.rowAccent.bar,
            bgcolor: "#FFFFFF",
            border: "1px solid rgba(148, 163, 184, 0.2)",
            "&:hover": {
              bgcolor: row.rowAccent.rowBg,
            },
          }}
        >
          <MdVisibility />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
